import { configureStore } from '@reduxjs/toolkit';

import authSlice from '../slices/authSlice.js'
import settingsSlice from '../slices/settingsSlice.js'

export default configureStore({
    reducer: {
        auth: authSlice,
        settings: settingsSlice,
    }
})